import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';

import SlideActions from "Components/SlideActions";
import SlidePreview from "Components/SlidePreview";

export default class SlideTrackItem extends React.Component
{
    static propTypes = {
        active: PropTypes.bool,
        slide: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
        changeElement: PropTypes.func.isRequired,
        selectSlide: PropTypes.func.isRequired,
    };

    static defaultProps = {
        active: false
    };

    render()
    {
        const classes = {
            row: classNames(
                'group relative flex cursor-pointer items-center space-x-2 p-4 pr-2',
                {
                    'bg-gray-200': this.props.active,
                    'hover:bg-gray-100': !this.props.active
                }
            ),
            position: 'text-gray-600 text-sm pr-2',
            controls: ''
        };

        return <div className={classes.row} onClick={this.props.onClick}>
            <div className={classes.position}>
                {this.props.slide.position}
            </div>
            <SlidePreview
                slide={this.props.slide}
                type={this.props.slide.type}
                active={this.props.active}
            />
            <div className={classes.controls}>
                <SlideActions
                    slide={this.props.slide}
                    changeSlide={this.props.onClick}
                    selectSlide={this.props.selectSlide}
                />
            </div>
        </div>;
    }
}
